export default __webpack_public_path__ + "assets/models/ebd24ae7583ab8de54da7ee9ac761018.gltf";